<template>
    <div>
        <div class="nav">
            <span>反馈对象:</span>
            <div>
                <span
                    v-for="(item, index) in nav1.arr"
                    :key="index"
                    :class="nav1.active == index ? 'active' : ''"
                    @click="nav1.active = index"
                    >{{ item }}</span
                >
            </div>
        </div>
        <div class="nav">
            <span>留言类型:</span>
            <div>
                <span
                    v-for="(item, index) in nav2.arr"
                    :key="index"
                    :class="nav2.active == index ? 'active' : ''"
                    @click="nav2.active = index"
                    >{{ item }}</span
                >
            </div>
        </div>
        <div class="nav">
            <span>处理状态:</span>
            <div>
                <span
                    v-for="(item, index) in nav3.arr"
                    :key="index"
                    :class="nav3.active == index ? 'active' : ''"
                    @click="nav3.active = index"
                    >{{ item }}</span
                >
            </div>
        </div>

        <div>记录列表</div>

		<div class="list">
			<div v-for="(item,index) in list" :key="index">
				{{item.content}}
			</div>
		</div>


        <div style="marginTop:20px">我要反馈</div>
        <div class="choose">
            <div>
                <span>反馈对象</span>
                <el-select v-model="choose.objVal" placeholder="请选择">
                    <el-option
                        v-for="item in choose.obj"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                    >
                    </el-option>
                </el-select>
            </div>
            <div>
                <span>留言类型</span>
                <el-select v-model="choose.typeVal" placeholder="请选择">
                    <el-option
                        v-for="item in choose.type"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                    >
                    </el-option>
                </el-select>
            </div>
            <div>
                <span>处理状态</span>
                <el-select v-model="choose.statusVal" placeholder="请选择">
                    <el-option
                        v-for="item in choose.status"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>

        <textarea
            v-model="content"
            style=" width: 100%; min-height: 150px; resize: none; outline: none;border:1px solid #DCDFE6;marginTop:10px "
        ></textarea>

        <el-button type="primary" @click="confirm">确定</el-button>

        
    </div>
</template>

<script>
export default {
    data() {
        return {
            choose:{
                objVal:'',
                obj:[
                    { label:'缩水网', value:1 },
                    { label:'EXCEL专区', value:2 },
                    { label:'缩水软件特区', value:3 },
                    { label:'实体投注站帮扶中心', value:4 },
                ],
                typeVal:'',
                type:[
                    { label:'建议', value:1 },
                    { label:'意见', value:2 },
                    { label:'求助', value:3 },
                    { label:'投诉', value:4 },
                ],
                statusVal:'',
                status:[
                    { label:'新提交', value:1 },
                    { label:'再提交', value:2 },
                    { label:'处理中', value:3 },
                    { label:'已回复', value:4 },
                    { label:'已解决', value:5 },
                ],
            },
            content:'',

            nav1: {
                arr: [
                    "全部",
                    "缩水网",
                    "EXCEL专区",
                    "缩水软件特区",
                    "实体投注站帮扶中心",
                ],
                active: 0,
            },
            nav2: {
                arr: ["全部", "建议", "意见", "求助", "投诉"],
                active: 0,
            },
            nav3: {
                arr: ["全部", "新提交", "再提交", "处理中", "已回复", "已解决"],
                active: 0,
            },

			list:[],

        };
    },
    watch:{
        'nav1.active'(){
            this.getList()
        },
        'nav2.active'(){
            this.getList()
        },
        'nav3.active'(){
            this.getList()
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
        getList(){
            this.$http.post('/user/guestbook',{
                user_id:JSON.parse(localStorage.getItem('lifeData')).vuex_userInfo.userId,
                object:this.nav1.active,
                type:this.nav2.active,
                status:this.nav3.active,
            }).then(res=>{
                console.log(res);
				this.list = res.data
            })
        },
        confirm(){
            let { objVal,typeVal,statusVal } = this.choose,
                content = this.content;
            
            if(!objVal){ this.$message.error('请选择反馈类型');return}
            if(!typeVal){ this.$message.error('请选择留言类型');return}
            if(!statusVal){ this.$message.error('请选择处理状态');return}
            if(!content){ this.$message.error('请输入反馈内容');return}


            this.$http.post('/user/guestbook/insert',{
              user_id:JSON.parse(localStorage.getItem('lifeData')).vuex_userInfo.userId,
                object:objVal,
                type:typeVal,
                status:statusVal,
                content
            }).then(res=>{
                console.log(res);
                this.choose.objVal = this.choose.typeVal = this.choose.statusVal =  this.content = ''
				this.getList()
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.list{
	border: rgba(0, 0, 0, 0.1) 1px solid;
	border-bottom: 0;
	>div{
		padding: 10px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}
}
.nav {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    > span {
        margin-right: 30px;
    }
    > div {
        span {
            background-color: #ededed;
            border: 1px solid #ededed;
            padding: 3px 10px;
            font-size: 15px;
            border-radius: 5px;
            margin-right: 20px;
            cursor: pointer;
            &.active {
                background-color: #fbeedc;
                border: 1px solid #eeb26a;
            }
        }
    }
}
.choose{
    display: flex;
    margin-top: 20px;
    >div{
        margin-right: 30px;
        display: flex;
        white-space: nowrap;
        align-items: center;
        >span{
            margin-right: 10px;
        }
    }
}
</style>